import * as React from 'react';
import { useTranslation } from 'react-i18next';

// Constants
import { API_URL } from '@src/shared/src/const/api';
// Styles
import './styles/SearchChoiceBanner.scss';

// The translations live at locize, not in this repo, so each label carries the German
// words of the design as its default until the keys are added there
const LABELS = {
  badge: { key: 'SearchChoiceBanner.badge', fallback: 'Neu' },
  title: { key: 'SearchChoiceBanner.title', fallback: 'Suchen & Buchen – komplett überarbeitet' },
  text: {
    key: 'SearchChoiceBanner.text',
    fallback: 'Wir haben die Such- und Buchungsstrecke von Grund auf neu gestaltet. Testen Sie jetzt selbst.',
  },
  button: { key: 'SearchChoiceBanner.button', fallback: 'Neue Suche testen' },
  close: { key: 'SearchChoiceBanner.close', fallback: 'Hinweis schließen' },
};

const NEW_SEARCH_URL = `${API_URL.DEFAULT}/search/new`;

// Offers the new search, which the backend serves, to an organisation that may use both.
// Closing it hides it only while this page stands: nothing is remembered.
export const SearchChoiceBanner: React.FC = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = React.useState(true);
  const label = (name: keyof typeof LABELS) => t(LABELS[name].key, { defaultValue: LABELS[name].fallback });

  if (!visible) {
    return null;
  }

  return (
    <div className="search-choice-banner">
      <span className="search-choice-banner-badge">{label('badge')}</span>
      <div className="search-choice-banner-words">
        <strong className="search-choice-banner-title">{label('title')}</strong>
        <span className="search-choice-banner-text">{label('text')}</span>
      </div>
      <a className="search-choice-banner-button" href={NEW_SEARCH_URL}>
        {label('button')}
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M3 8h10M9 4l4 4-4 4" />
        </svg>
      </a>
      <button
        type="button"
        className="search-choice-banner-close"
        aria-label={label('close')}
        onClick={() => setVisible(false)}
      >
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
          <path d="M4 4l10 10M14 4L4 14" />
        </svg>
      </button>
    </div>
  );
};

export default SearchChoiceBanner;
